// src/auth/backend-origin.ts
function normalizeOrigin(origin: string): string {
    return origin.replace(/\/$/, '');
}

export function getBackendOrigin(): string {
    // Optionaler Override via Vite Env (zur Build-Zeit ersetzt)
    const fromEnv = import.meta.env.VITE_BACKEND_ORIGIN as string | undefined;
    if (fromEnv && fromEnv.trim().length > 0) {
        return normalizeOrigin(fromEnv);
    }

    // Laufzeit: Origin der aktuell geladenen App
    return normalizeOrigin(location.origin);
    /*if (location.origin) {
        return normalizeOrigin(window.location.origin);
    }*/

    // SSR/Tests Fallback (solltest du bewusst setzen)
    // return 'http://localhost:14801';
}
